module.exports = __webpack_public_path__ + "static/media/Human_ZG4874_360.7b9938ba.jpeg";